import $ from 'jquery';

let limit = 2;
let selectClass = '.region-select .custom-control-input';

$(selectClass).on('change', function() {
    if($(selectClass+':checked').length > limit) {
        this.checked = false;
    }
});
